module.exports = __webpack_public_path__ + "static/normal-b-a33d50da063b016852d1d139cf6e73b1.jpg";